import React, { CSSProperties, useEffect } from 'react';
import { toastMessage } from '@croquiscom-pvt/content-ui';
import { IconMinusBold, IconPlusBold } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { themeTokens } from '@croquiscom-pvt/zds/tokens/zigzag';
import styled from '@emotion/styled';

import { BaseText, Button } from '@common/toolbox';

interface Props extends React.HTMLProps<HTMLDivElement> {
  disabled?: boolean;
  minDisabled?: boolean;
  count: number;
  min_count?: number;
  max_count?: number;
  amount_count?: number;
  under_min_message?: string;
  over_max_message?: string;
  onInit?: (count: number) => void;
  changeEvent?: (count: number) => void;
}

export const Counter = ({
  className,
  disabled = false,
  minDisabled = false,
  count,
  min_count = 0,
  max_count = 9999,
  amount_count = 1,
  under_min_message,
  over_max_message,
  onInit = () => undefined,
  changeEvent = () => undefined,
}: Props) => {
  const toast_style: CSSProperties = {
    position: 'relative',
    bottom: '60px',
    maxWidth: 560,
    margin: '0 auto',
  };
  const increase = () => {
    if (count < max_count && !disabled) {
      changeEvent(count + amount_count);
    } else if (over_max_message) {
      toastMessage(over_max_message, undefined, { toast_style });
    }
  };

  const decrease = () => {
    if (minDisabled) {
      return;
    }
    if (count > min_count && !disabled) {
      changeEvent(count - amount_count);
    } else if (under_min_message) {
      toastMessage(under_min_message, undefined, { toast_style });
    }
  };

  useEffect(() => {
    onInit(count);
  }, []);

  return (
    <Container className={className}>
      <Button
        className={'counter_btn'}
        onClick={decrease}
        button_icon={
          <IconMinusBold size={20} v3Color={minDisabled || disabled || min_count >= count ? 'gray400' : 'gray950'} />
        }
      />
      <CountWrapper>
        <BaseText variation='BODY_16_REGULAR' color={themeTokens.v3Color.gray900.value.light}>
          {count}
        </BaseText>
      </CountWrapper>
      <Button
        className={'counter_btn'}
        onClick={increase}
        button_icon={<IconPlusBold size={20} v3Color={disabled || max_count <= count ? 'gray400' : 'gray950'} />}
      />
    </Container>
  );
};

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  min-width: 96px;
  height: 32px;

  .counter_btn {
    width: 20px;
    vertical-align: middle;
  }
`;

const CountWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 40px;
  height: 32px;
  margin: 0 4px;
  border-radius: 8px;
  border: 1px solid ${vars.v3Color.gray150};
  background-color: ${vars.v3Color.white};

  &::before {
    content: '';
    height: 100%;
  }
`;
